import { Component,OnInit,ViewChild } from '@angular/core';
import { NavController, NavParams,Refresher,LoadingController,ToastController,Content,AlertController } from 'ionic-angular';
import { Api } from '../../providers/api/api';
import { Usuario } from '../../entities/usuario';
import { Grupo } from '../../entities/grupo';
import { LoteDAO } from '../../daos/lote-dao';
import { DTOObterLote } from '../../dto/dtoObterLote';

import _ from 'lodash';


@Component({
  selector: 'page-receber-lote-home',
  templateUrl: 'receber-lote-home.html',
})
export class ReceberLoteHomePage implements OnInit {
  @ViewChild('content') content: Content;

  private _idsDosGruposSelecionados: number[] = [];
  public usuario: Usuario;
  public obterLotes: DTOObterLote[] = [];
  public lotesAgrupados: { grupo: Grupo, obterLotes: DTOObterLote[] }[] = []; 
  public lotesAgrupadosRaiz: { grupo: Grupo, obterLotes: DTOObterLote[] }[] = [];
  public grupos: Grupo[] = [];
  searchTerm: string; 
  
  constructor(public navCtrl: NavController,
    private _toastCtrl: ToastController,
    private _loadingCtrl: LoadingController,
    private _alertCtrl: AlertController,
    private _api: Api,
    private _loteDao: LoteDAO,
    public _navParams: NavParams) {    
    this.usuario = _navParams.get('usuario');
  }

  ngOnInit(): void {
    this.listarLotes();
  }

  private _obterLote(idEmpresa: number, perfil: String): Promise<DTOObterLote[]> {
    return new Promise((resolve, reject) => {
      this._api.get(`LoteRecebido/ListaLoteEmpresa/${idEmpresa}/${perfil}`).subscribe(response =>         
        resolve(JSON.parse(response._body)), reject);               
  
    });
  }

  public listarLotes(refresher?: Refresher): void {
    let load = this._loadingCtrl.create({ content: 'Obtendo lotes...' });
    if (!refresher)
        load.present();

    this.grupos = [];
        
    this._obterLote(this.usuario.Empresa.Id, this.usuario.Perfil).then(obterLotes => {
        console.log(obterLotes);
        this.lotesAgrupadosRaiz = [];
        this.lotesAgrupados = [];      
       // obterLotes = obterLotes.filter(item => _.isEqual(item.RecebeLote.Usuario.Id, this.usuario.Id));        
        this.obterLotes = obterLotes;

        _.uniqBy(this.obterLotes.map(obterLotes => obterLotes.Grupo), 'Id').forEach(grupo => {
            this.grupos.push(grupo);
            let agrupamento = { grupo: grupo, obterLotes: this.obterLotes.filter(a => _.isEqual(a.Grupo.Id, grupo.Id)) };
            this.lotesAgrupadosRaiz.push(agrupamento);
            this.lotesAgrupados.push(agrupamento);
        });
        if (!refresher) load.dismiss(); else refresher.complete();
    }).catch(error => {
        console.error(error);
        if (!refresher) load.dismiss(); else refresher.complete();
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter lotes recebidos. Tente novamente!',
            duration: 3000
        }).present();
    });
  }

  

  public filtros(): void {
    let alert = this._alertCtrl.create({ title: 'Filtro por Grupo', subTitle: 'Selecione grupos para filtrar' });

    this.grupos.forEach(grupo => {
        alert.addInput({
            type: 'checkbox', label: grupo.Descricao, value: grupo.Id.toString(), checked: _.includes(this._idsDosGruposSelecionados, grupo.Id)
        });
    });

    alert.addButton('Cancelar');
    alert.addButton({
        text: 'Ok',
        handler: data => {   
            data = data.map(Math.floor);
            if (!_.isEqual(this._idsDosGruposSelecionados, data)) {
                this._idsDosGruposSelecionados = data;
                this._filtrarCategorias();
            }
        }
    });

    alert.present();
  }

  private _filtrarCategorias() {
    let load = this._loadingCtrl.create({ content: 'Atualizando listagem...' });

    if (this._idsDosGruposSelecionados.length > 0) {
        load.present();
        this.content.scrollToTop().then(() => {
            this.lotesAgrupados = [];

            this._idsDosGruposSelecionados.forEach(idGrupo => {
                this.lotesAgrupados = _.union(this.lotesAgrupados, this.lotesAgrupadosRaiz.filter(a => a.grupo.Id === idGrupo));
            });

            load.dismiss();
        });
    } else if (!_.isEqual(this.lotesAgrupados, this.lotesAgrupadosRaiz)) {
        load.present();

        this.content.scrollToTop().then(() => {
            this.lotesAgrupados = this.lotesAgrupadosRaiz;
            load.dismiss();
        });
    }
  }

  public remover(obterLote: DTOObterLote): void {
    this._alertCtrl.create({
        title: 'Têm certeza que deseja remover o lote?',
        subTitle: `Após a confirmação, o lote ${obterLote.RecebeLote.NumLote}  será removido.`,
        inputs: [
            {
                name: 'Senha',
                type:"password",
                placeholder: 'Senha...' 

            },
        ],
        buttons: [
            {
                text: 'Não',
                role: 'destructive'
            },
            {
                text: 'Sim',
                handler: (data) => {
                  
                  if (_.isEqual(data.Senha, '753')){
                    this._loteDao.removerLote(obterLote.RecebeLote.Id).then(() => {
                      this.listarLotes();
                    }).catch(error => {
                      console.info(error);
                      this._toastCtrl.create({
                          message: 'Ocorreu um erro ao tentar remover o lote. Tente novamente!',
                          duration: 3000
                      }).present();
                    });
                  }else{
                    this._toastCtrl.create({
                      message: 'Senha inválida, tente novamente!',
                      duration: 3000
                    }).present();                    
                  }
                  
                    
                    
                }
            }
        ]
    }).present();
  }



}



// WEBPACK FOOTER //
// ./src/pages/receber-lote-home/receber-lote-home.ts